import React, { useState } from "react";
import { Form, Input, Button, notification, Icon } from "antd";
import { Redirect } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";

import Header from "../../../User/Header";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description,
        iconLoading: false
    });
};

const RecuperarPassword = ({ form, match }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [redirect, setRedirect] = React.useState(false);
    const [redirectLink, setRedirectLink] = React.useState("");

    const handleSubmit = e => {
        e.preventDefault();

        form.validateFields((err, values) => {
            if (!err) {
                handleResetPassword(values);
            }
        });
    };

    const handleResetPassword = registo => {
        setIsLoading(true);

        axios({
            method: "get",
            url: "/api/autenticacaonew/recuperar-senha",
            params: {
                email: registo.email,
                url: match.params.entidade
            }
        })
            .then(() => {
                openNotificationWithIcon("success", "Sucesso", "E-mail de recuperação de senha enviado!");

                setRedirectLink(`/${match.params.entidade}/login-escola`);
                setRedirect(true);
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível enviar o e-mail de recuperação");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const { getFieldDecorator } = form;

    if (redirect) return <Redirect to={redirectLink} />;

    return (
        <>
            <Header titulo="Recuperar Password" marginTop0={true} />
            <Form className="login template-form" onSubmit={handleSubmit}>
                <div className="recuperar-password" style={{ paddingTop: 24 }}>
                    <Form.Item>
                        {getFieldDecorator("email", {
                            rules: [
                                {
                                    required: true,
                                    message: "Introduza o e-mail"
                                },
                                {
                                    type: "email",
                                    message: "Introduza um e-mail válido"
                                }
                            ]
                        })(<Input placeholder="E-mail" />)}
                    </Form.Item>
                </div>
                <Form.Item style={{ marginBottom: 0 }}>
                    <Button type="primary" htmlType="submit" className="login-form-button form-button" disabled={isLoading}>
                        {isLoading ? <Icon type="loading" /> : null}
                        Recuperar
                    </Button>
                    <div className="bloco-login-links">
                        <Link to={`/${match.params.entidade}/login-escola`} className="form-link">
                            Voltar <i className="fas fa-chevron-right"></i>
                        </Link>
                    </div>
                </Form.Item>
            </Form>
        </>
    );
};

const FormRecuperarPassword = Form.create({ name: "recuperar-password" })(RecuperarPassword);

export default FormRecuperarPassword;
